import BaseNotification from '#BASE/components/notification/notification.base.component';
import signalr from 'BASE/common/signalrAdapter';
import { actionTypes } from 'BASE/store/types';
export default {
    mixins: [BaseNotification],
    created() {
        let _this = this;
        signalr.addWorkOnConnected(() => {
            signalr.betAwardNotifyClient.betAwardNotify.addHandler(this.checkAwardNotify);
        });
    },
    beforeDestroy() {
        if (signalr.isInitialized) {
            signalr.betAwardNotifyClient.betAwardNotify.removeHandler(this.checkAwardNotify);
        }
    },
    computed: {
        hideAwardNotify() {
            return this.$store.state.userinfo.hideAwardNotify;
        },
    },
    methods: {
        async checkAwardNotify(result) {
            if (!this.hideAwardNotify) {
                this.add(result);
            }
        },
        switchBetAwardNotify() {
            let _hideAwardNotify = !this.hideAwardNotify;
            this.$store.dispatch(actionTypes.USER_INFO_HIDE_AWARD_NOTIFY, { hideAwardNotify: _hideAwardNotify });
        },
    },
};
